import React from 'react';
import { apiClient } from './../API/Auth/apiClient';

export interface IUserContext {
	isLogged: boolean;
	userId: string | null;
	userLogin: string | null;
	userName: string | null;
	userRoles: string[];
	userWorkplaceId: string | null;
	availableFunctionalities: number | null;
}

export const initialUserContext: IUserContext = {
	isLogged: false,
	userId: null,
	userName: null,
	userLogin: null,
	userRoles: [],
	userWorkplaceId: null,
	availableFunctionalities: null,
};

const tokenData = apiClient.getUserDataFromAccessToken();

if (tokenData != null) {
	initialUserContext.isLogged = tokenData.id != null;
	initialUserContext.userId = tokenData.id;
	initialUserContext.userName = tokenData.name;
	initialUserContext.userLogin = tokenData.userName;
	initialUserContext.userRoles = tokenData.roles;
	initialUserContext.userWorkplaceId = tokenData.userWorkplaceId;
	initialUserContext.availableFunctionalities = tokenData.availableFunctionalities;
}

export const UserContext = React.createContext<IUserContext>(initialUserContext);
